import {
  store
} from "..";
import handler from "./realtime-handler";
import {
  grabserviceredux
} from "../services/crudservice";
const update = payload => {
  // console.log("Handling new Assignment", payload.service);

  if (payload.service === "assign") {
    grabserviceredux('assign', 'jobReducer')
    handler.assign(payload.result);
  }
  switch (payload.service) {
    case "assign":
      handler.assign(payload.result);

      break;
    case "edfemployees":
      handler.employee(payload.result);

      break;
    default:
  }

  return {
    type: "Feathers Update > " + payload.service,
    key: payload.key,
    payload: payload.result,
    method: payload.method,
    deletestatus: payload.method === "remove" ? true : false
  };
};
export default update;


// WEBPACK FOOTER //
// ./src/actions/socket-handle.js